import axios from 'axios';
import BaseMitPageLoadingService from './BaseMitPageLoadingService.js';

class BaseMitRequestInterceptorService {
  constructor(userService, appRouter) {
    // // Add a response interceptor
    axios.interceptors.response.use( (response) => {
      return response;
    }, (error) => {
      return new Promise((resolve, reject) => {
        if (error && error.response && error.response.status === 401 && userService.isLoggedIn()) {
            BaseMitPageLoadingService.showLoading(true);
            if(error.response.data && error.response.data.actionRequired === 'duo-challenge'){
                console.log('Server needs a duo check token');
                window.location.href = '/auth/duo?returnUrl='+window.location.href;
                return reject(error);
            }

            userService.clearCurrentUser()
              .then((res) => {
                window.location.href = '/';
                return reject(error);
                return reject(error);
              })
        }
        else if (error && error.response && error.response.status === 403) {
          //have logged in fine, but this user is not allowed access
          appRouter.push({name:'no-access'});
          return reject(error);
        }
        else{
          return reject(error);
        }
      });
    });
  }


}

export default BaseMitRequestInterceptorService;
